import React, { Suspense, useState } from "react";
import { Link } from "react-router-dom";
import TrashBotGame from "./TrashBotGame";
import RecycleGame from "./RecycleGame";
import EcoBattleGame from "./EcoBattleGame";
import EcoNightPatrol from "./EcoNightPatrol";
import { useReveal } from "./useReveal";
import "./GamePage.css";

const MissionNYC = React.lazy(() => import("./MissionNYC"));

const GamePage: React.FC = () => {
  useReveal();
  const [game, setGame] = useState<"trashbot" | "recycle" | "battle" | "patrol" | "city3d">("city3d");
  return (
    <div className="ee-game-page">
      <div className="ee-game-hero">
        <div className="ee-container ee-game-hero-inner">
          <div className="ee-game-kicker">★ The Eco-Allies Arcade ★</div>
          <h1 className="ee-game-h1">EARTH JR.'S ARCADE</h1>
          <p className="ee-game-tag">
            Five games, one mission — play as <strong>Earth Jr.</strong> 🌎, save the city, and
            learn to recycle like a pro. For all ages!
          </p>
        </div>
      </div>

      <div className="ee-container ee-game-body">
        <div className="ee-game-tabs">
          <button className={`ee-game-tab${game === "city3d" ? " active" : ""}`} onClick={() => setGame("city3d")}>🗽 Mission NYC</button>
          <button className={`ee-game-tab${game === "patrol" ? " active" : ""}`} onClick={() => setGame("patrol")}>🌃 Night Patrol</button>
          <button className={`ee-game-tab${game === "battle" ? " active" : ""}`} onClick={() => setGame("battle")}>⚡ Battle for NYC</button>
          <button className={`ee-game-tab${game === "trashbot" ? " active" : ""}`} onClick={() => setGame("trashbot")}>🤖 Trash-Bot Rises</button>
          <button className={`ee-game-tab${game === "recycle" ? " active" : ""}`} onClick={() => setGame("recycle")}>♻️ Recycle or Trash?</button>
        </div>

        {game === "city3d" ? (
          <Suspense fallback={<div className="tbg-wrap"><div className="tbg-stage" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: 320, color: "#fff", fontFamily: "'Bangers', sans-serif", fontSize: 24 }}>LOADING THE CITY…</div></div>}>
            <MissionNYC />
          </Suspense>
        ) : game === "patrol" ? <EcoNightPatrol /> : game === "battle" ? <EcoBattleGame /> : game === "trashbot" ? <TrashBotGame /> : <RecycleGame />}

        <div className="ee-game-how ee-section" style={{ padding: "40px 0 0" }}>
          <div className="ee-game-how-grid">
            <div className="ee-game-how-card"><div className="ee-game-how-ico">🌎</div><strong>Catch recyclables</strong><span>Move Earth Jr. to grab e-waste, clothes & cans.</span></div>
            <div className="ee-game-how-card"><div className="ee-game-how-ico">🤖</div><strong>Shrink Trash-Bot</strong><span>Every catch weakens the boss. Empty its bar to win!</span></div>
            <div className="ee-game-how-card"><div className="ee-game-how-ico">🛢️</div><strong>Dodge the junk</strong><span>Don't grab oil, bombs & smog — that costs a heart.</span></div>
          </div>
        </div>

        <div className="ee-game-saga">
          <div className="ee-game-kicker" style={{ textAlign: "center" }}>☠ THE TRASH-BOT SAGA ☠</div>
          <p className="ee-game-saga-sub">He gets stronger every time something valuable gets thrown away. Each chapter, a bigger boss…</p>
          <div className="ee-game-saga-row">
            {[
              { img: "trashbot_mk1.png", name: "MK I", tag: "Chapter 1" },
              { img: "trashbot_mk2.png", name: "MK II", tag: "Coming" },
              { img: "mega_trashbot.png", name: "MEGA", tag: "Coming" },
              { img: "landfill_titan.png", name: "LANDFILL TITAN", tag: "Coming" },
              { img: "king_trashbot.png", name: "KING TRASH-BOT", tag: "Finale" },
            ].map((b) => (
              <div key={b.name} className="ee-game-saga-card">
                <img src={`${process.env.PUBLIC_URL}/${b.img}`} alt={`${b.name} — Trash-Bot form`} />
                <strong>{b.name}</strong>
                <span>{b.tag}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="ee-game-cta">
          <p>Loved it? Be a real-life Eco-Hero. 💚</p>
          <div className="ee-game-cta-btns">
            <Link to="/pickup" className="ee-btn ee-btn-green">📦 Schedule a Free Pickup</Link>
            <Link to="/#ecoheroes" className="ee-btn ee-btn-ghost" style={{ color: "var(--text)" }}>See the Comics & Toys →</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GamePage;
